
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import { CheckCircle, Security, Timer, Assessment } from '@mui/icons-material';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleStartTest = () => {
    navigate('/register');
  };

  const topics = [
    'Mathematics & Logic',
    'English Language',
    'General Knowledge',
    'Technical Skills',
    'Analytical Reasoning',
    'Computer Science',
    'Linux',
    'Cybersecurity',
    'Programming',
    'Networking',
    'Other Sciences',
    'etc'
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
<img src="https://img.icons8.com/fluency/96/test-passed.png" alt="logo" style={{ width: 80, height: 80, marginBottom: 16 }} />
        
        <Typography variant="h3" gutterBottom color="primary">
          Automated Evaluation System
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mb: 4, color: 'text.secondary' }}>
          Multi-Purpose Aptitude & Assessment Platform
        </Typography>

        <Typography variant="body1" paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          A comprehensive evaluation platform for institutions, organizations, and trainers. 
          Create customized exams, assess participants across any subject domain, and 
          generate detailed performance reports — all without requiring participant accounts.
        </Typography>

        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Timer sx={{ fontSize: 40, color: 'secondary.main', mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Time Limit
                </Typography>
                <Typography variant="body2">
                  Configurable time limits per exam. Auto-submits when time expires.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Assessment sx={{ fontSize: 40, color: 'secondary.main', mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Multiple Choice
                </Typography>
                <Typography variant="body2">
                  Customizable question formats with instant scoring and detailed feedback.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Security sx={{ fontSize: 40, color: 'secondary.main', mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Secure & Confidential
                </Typography>
                <Typography variant="body2">
                  All responses are securely encrypted and stored for future reference and analysis.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Paper elevation={1} sx={{ p: 3, mb: 4, textAlign: 'left' }}>
          <Typography variant="h6" gutterBottom>
            Topics Covered:
          </Typography>
          <Grid container spacing={1}>
            {topics.map((topic, index) => (
              <Grid item xs={6} sm={4} md={3} key={index}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
                  <CheckCircle color="primary" fontSize="small" />
                  <Typography variant="body2">{topic}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>

        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            onClick={handleStartTest}
            sx={{ py: 1.5, px: 6, fontSize: '1.1rem' }}
          >
            Start Assessment
          </Button>
          <Typography variant="body2" color="text.secondary">
            Are you a trainer or instructor?{' '}
            <Button
              size="small"
              onClick={() => navigate('/admin/login')}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            >
              Login to Dashboard
            </Button>
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ mt: 4, color: 'text.secondary' }}>
          Note: You'll need a valid email address to participate. Each exam must be completed in one session.
        </Typography>
      </Paper>
    </Container>
  );
};

export default LandingPage;